/* unplugin-vue-components disabled */import { render } from "./FooterForPC.vue?vue&type=template&id=1eea4140&scoped=true"
import script from "./FooterForPC.vue?vue&type=script&lang=js"
export * from "./FooterForPC.vue?vue&type=script&lang=js"

import "./FooterForPC.vue?vue&type=style&index=0&id=1eea4140&lang=less&scoped=true"

import exportComponent from "/Users/jiaohong/Documents/code/workSpace/kuaitandain-official-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1eea4140"]])

export default __exports__